import script from "./locked-drawer-empty-state.vue?vue&type=script&setup=true&lang=ts"
export * from "./locked-drawer-empty-state.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__